export default __webpack_public_path__ + "static/media/icon-settings.bd2c4c19.svg";